import { useLang } from 'hooks/lang';

import { isLeader, projectStatusConfig, isInvoiceRepriceActive, actions } from 'entities';

import { ToggleRightIcon } from 'components/Icons';

import { useSingleJustification } from 'providers/Justification';
import { useToast } from 'providers/Toast';
import { useConfirmation } from 'providers/Confirmation';
import { useProjectProfile } from '../../context';

import { MESSAGES } from '../../utils';

import { registerProjectOption } from '../options';

export default registerProjectOption({
  Icon: ToggleRightIcon,

  getLabel: (t) => t('reactivate-project'),

  action: 'REACTIVATE_PROJECT',

  useOption: ({ loggedUser, project }) => {
    const { updateProject } = useProjectProfile();

    const { requestConfirmation } = useConfirmation();
    const { addToast } = useToast();

    const { t } = useLang();

    const reactivateProject = actions.projects.reactivateProject.use({
      onSuccess: () => {
        updateProject((old) => ({
          ...old,
          status: projectStatusConfig.started.code,
          completedAt: undefined,
          finished: false,
        }));
      },
    });

    const canReactivateProject = [
      projectStatusConfig.done.code === project.status,
      loggedUser.id === project.owner.id ||
        (project.owner.team === loggedUser.team.id && isLeader(loggedUser)),
      !isInvoiceRepriceActive(project),
    ].every(Boolean);

    const handleReactivateProjectClick = useSingleJustification({
      cancel: () => addToast(MESSAGES.reactivateProjectAborted(t)),
      text: t('what-is-the-reason-for-this-reactivation-please-be-sure-it-is-necessary'),

      onConfirm: async (justification) =>
        requestConfirmation({
          cancel: () => addToast(MESSAGES.reactivateProjectAborted(t)),

          type: 'normal',
          title: `${t('reactivate-project')}?`,
          text: t('the-task-owners-will-be-notified-and-the-project-will-become-available-again'),

          onConfirm: async () => {
            await reactivateProject.execute({
              project: project.id,
              justification,
            });
          },
        }),
    });

    return {
      action: handleReactivateProjectClick,

      isEnabled: canReactivateProject,

      loading: reactivateProject.loading,
    };
  },
});
